const reader = document.getElementById('reader');
let previousFocus;
document.querySelectorAll('[data-read]').forEach(button => button.addEventListener('click', () => {
  previousFocus = button;
  reader.showModal();
  reader.scrollTop = 0;
  document.getElementById('close-reader').focus({preventScroll:true});
}));
const closeReader = () => reader.close();
document.getElementById('close-reader').addEventListener('click', closeReader);
document.getElementById('finish-reading').addEventListener('click', closeReader);
reader.addEventListener('click', event => { if (event.target === reader) { const box=reader.getBoundingClientRect(); if(event.clientX<box.left||event.clientX>box.right||event.clientY<box.top||event.clientY>box.bottom) closeReader(); } });
reader.addEventListener('close', () => previousFocus?.focus({preventScroll:true}));

document.addEventListener('change', event => {
  if (!event.target.matches('[data-variant-select]')) return;
  const option = event.target.selectedOptions[0];
  const form = event.target.closest('form');
  const price = form.querySelector('[data-price]');
  if (price) price.textContent = option.dataset.price;
  const button = form.querySelector('[data-add-to-cart]');
  if (button) {
    const available = option.dataset.available === 'true';
    button.disabled = !available;
    button.textContent = available ? button.dataset.addLabel : button.dataset.unavailableLabel;
  }
});
const cartDrawer = document.getElementById('cart-drawer');
const cartDrawerOverlay = document.getElementById('cart-drawer-overlay');
const cartDrawerClose = document.getElementById('cart-drawer-close');
const cartDrawerItems = document.getElementById('cart-drawer-items');
const cartDrawerCount = document.getElementById('cart-drawer-count');
const cartDrawerTotal = document.getElementById('cart-drawer-total');

function formatMoney(cents, currency = 'USD') {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency
  }).format(cents / 100);
}

function openCartDrawer() {
  cartDrawer.classList.add('is-open');
  cartDrawer.setAttribute('aria-hidden', 'false');
  cartDrawerOverlay.hidden = false;
}

function closeCartDrawer() {
  cartDrawer.classList.remove('is-open');
  cartDrawer.setAttribute('aria-hidden', 'true');
  cartDrawerOverlay.hidden = true;
}

async function refreshCartDrawer() {
  const response = await fetch('/cart.js');
  const cart = await response.json();

  cartDrawerCount.textContent = `(${cart.item_count})`;
  cartDrawerTotal.textContent = formatMoney(cart.total_price, cart.currency);

  if (!cart.items.length) {
    cartDrawerItems.innerHTML = `
      <div class="cart-empty-state">
        <p>Your cart is empty.</p>
        <span>Add a format of WHERE KNOWLEDGE ENDS to continue.</span>
      </div>
    `;
    return;
  }

  cartDrawerItems.innerHTML = cart.items.map((item, index) => `
    <div class="cart-drawer-item" data-line="${index + 1}">

      <div class="cart-item-image-wrap">
        ${
          item.image
            ? `<img
                src="${item.image}"
                alt="${item.product_title}"
                class="cart-item-image"
                width="78"
                height="102"
              >`
            : ''
        }
      </div>

      <div class="cart-item-info">
        <div class="cart-item-top">
          <div>
            <p class="cart-drawer-item-title">${item.product_title}</p>

            ${
              item.variant_title && item.variant_title !== 'Default Title'
                ? `<p class="cart-item-variant">${item.variant_title}</p>`
                : ''
            }
          </div>

          <strong class="cart-item-price">
            ${formatMoney(item.final_line_price, cart.currency)}
          </strong>
        </div>

        <div class="cart-item-bottom">
          <div class="cart-item-quantity">
            <button
              type="button"
              class="cart-qty-button"
              data-cart-minus
              data-line="${index + 1}"
              aria-label="Decrease quantity"
            >−</button>

            <span>${item.quantity}</span>

            <button
              type="button"
              class="cart-qty-button"
              data-cart-plus
              data-line="${index + 1}"
              aria-label="Increase quantity"
            >+</button>
          </div>

          <button
            type="button"
            class="cart-remove"
            data-cart-remove
            data-line="${index + 1}"
          >REMOVE</button>
        </div>
      </div>

    </div>
  `).join('');
}
async function changeCartLine(line, quantity) {
  const response = await fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    },
    body: JSON.stringify({
      line: line,
      quantity: quantity
    })
  });

  if (!response.ok) return;

  await refreshCartDrawer();
}

document.addEventListener('click', async event => {
  const minusButton = event.target.closest('[data-cart-minus]');
  const plusButton = event.target.closest('[data-cart-plus]');
  const removeButton = event.target.closest('[data-cart-remove]');

  if (minusButton) {
    const line = Number(minusButton.dataset.line);
    const item = minusButton.closest('.cart-drawer-item');
    const currentQuantity = Number(
      item.querySelector('.cart-item-quantity span').textContent
    );

    await changeCartLine(line, Math.max(0, currentQuantity - 1));
  }

  if (plusButton) {
    const line = Number(plusButton.dataset.line);
    const item = plusButton.closest('.cart-drawer-item');
    const currentQuantity = Number(
      item.querySelector('.cart-item-quantity span').textContent
    );

    await changeCartLine(line, currentQuantity + 1);
  }

  if (removeButton) {
    const line = Number(removeButton.dataset.line);
    await changeCartLine(line, 0);
  }
});
document.querySelectorAll('form').forEach(form => {
  if (!form.querySelector('[data-add-to-cart]')) return;
  
  form.addEventListener('submit', async event => {
    if (event.submitter && event.submitter.closest('.shopify-payment-button')) return;

    event.preventDefault();

    const formData = new FormData(form);
    formData.delete('return_to');

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Accept': 'application/json'
      },
      body: formData
    });

    if (!response.ok) return;

    await refreshCartDrawer();
    openCartDrawer();
  });
});

cartDrawerClose?.addEventListener('click', closeCartDrawer);
cartDrawerOverlay?.addEventListener('click', closeCartDrawer);

document.addEventListener('keydown', event => {
  if (event.key === 'Escape') closeCartDrawer();
});